import { styled, Text, useTranslation } from '@obvio/app'
import { Stack } from '@obvio/ui'

import { Overlay } from './Overlay'
import { RegisterMoreButton } from './RegisterMoreButton'

import type { AllowUndefinedForOptional } from '@obvio/utils'
import type { ReactElement } from 'react'

const TextStack = styled(Stack)`
  margin-left: auto;
  margin-right: auto;
`

const Title = styled(Text)`
  margin-bottom: 0;
  font-size: 3.25rem;
`

const ContentStack = styled(Stack)`
  width: 100%;
  max-width: 68.25rem;
  margin: 0 auto;
`

type EventResponseProps = AllowUndefinedForOptional<{
  decline: boolean
  eventId: string
  onNewClick?(): void
  close(): void
}>

export function EventResponse({
  close,
  decline,
  eventId,
  onNewClick,
}: EventResponseProps): ReactElement {
  const { t } = useTranslation()
  return (
    <Overlay close={close}>
      <ContentStack kind="vertical" spacing="large">
        <TextStack kind="vertical" spacing="extraSmall">
          <Title tag="h2">{t('event.responseThanks')}!</Title>
          {decline ? (
            <Text>{t('event.notRegistered')}</Text>
          ) : (
            <RegisterMoreButton onNewClick={onNewClick} id={eventId} />
          )}
        </TextStack>
      </ContentStack>
    </Overlay>
  )
}
